import BaseListagem from "components/BaseListagem";
import Conta from "model/administracao/cadastro/Conta";
import Pessoa from "model/administracao/cadastro/Pessoa";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { InputNumber } from "primereact/inputnumber";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ContaService from "service/administracao/cadastro/ContaService";
import PessoaService from "service/administracao/cadastro/PessoaService";
import { ListMatchModeOptions, NumberMatchModeOptions, TextMatchModeOptions, filterApplyTemplate, numberFilterTemplate, statusFilterTemplate } from "utils/filterUtils";

const pessoaService = new PessoaService();

export default function PessoaListagem() {

    const [queryParameters] = useSearchParams();

    const [titulo, setTitulo] = useState<string>('Pessoas');

    const defaultFilters: DataTableFilterMeta = {
        codigoInterno: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        nome: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        tipo: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    const statusFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <MultiSelect value={options.value} options={pessoaService.getTiposPessoaFilter()} 
            onChange={(e: MultiSelectChangeEvent) => options.filterCallback(e.value)} 
            optionLabel="label" optionValue="value" placeholder="Qualquer" className="p-column-filter" 
        />;
    };

    const numberFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <InputNumber 
            value={options.value} onValueChange={(e) => options.filterCallback(e.value)} 
            useGrouping={false} minFractionDigits={0} maxFractionDigits={0} 
            placeholder="Escreva o filtro"    
        />;
    }
    return (

        <BaseListagem ordenacao="nome,ASC" service={pessoaService} urlService="/pessoa" tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton nome="pessoa">
            <Column 
                field="codigoInterno" header="Código" style={{ width: 50 }} filter showFilterOperator={false} showAddButton={false} filterElement={numberFilterTemplate}
                filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column 
                field="nome" header="Nome" filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} filterPlaceholder="Escreva o filtro"
            />
            <Column 
                body={(rowData: Pessoa) => pessoaService.getTipoPessoa(rowData.tipo)}
                field="tipo" header="Tipo" filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate} filterElement={statusFilterTemplate}
            />
        </BaseListagem>
    )
}
